module.exports = __webpack_public_path__ + "img/horn_2.1d79d622.png";